<template>
  <BSelectModalWithValidation
    :label="label"
    :displayValue="iconModel"
    :displayIcon="iconModel"
    :data="selectedIconGroup"
    v-model="iconModel"
    @modalShown="resetSelectedGroup"
  >
    <template #options="{ searchResult, updateModel, close }">
      <div class="columns is-multiline is-mobile">
        <div v-for="icon in searchResult" :key="icon" class="column is-2">
          <b-button
            :title="icon"
            :icon-right="icon"
            size="is-medium"
            :type="iconModel === icon ? 'is-gold' : 'is-text'"
            @click="
              updateModel(icon);
              close();
            "
          />
        </div>
      </div>
    </template>

    <template #footer>
      <div class="columns is-mobile">
        <div class="column" v-for="key in iconLibKeys" :key="key">
          <b-tooltip :label="iconLib[key].label">
            <b-button
              :icon-right="iconLib[key].icon"
              :type="selectedIconLibKey === key ? 'is-light' : 'is-text'"
              @click="selectedIconLibKey = key"
            />
          </b-tooltip>
        </div>
      </div>
    </template>
  </BSelectModalWithValidation>
</template>

<script>
import BSelectModalWithValidation from "@/components/inputs/BSelectModalWithValidation.vue";
import iconLib from "@/config/icon";

export default {
  name: "IconPicker",
  components: {
    BSelectModalWithValidation
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      iconLib,
      selectedIconLibKey: "emoji"
    };
  },
  computed: {
    iconModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    iconLibKeys() {
      return Object.keys(this.iconLib);
    },
    selectedIconGroup() {
      return this.iconLib[this.selectedIconLibKey].members;
    }
  },
  methods: {
    resetSelectedGroup() {
      // Reset the selected group to the group of the currently selected icon
      if (!this.value) return;

      const selectedIconGroup = this.iconLibKeys.reduce((selected, key) => {
        if (this.iconLib[key].members.includes(this.value)) {
          // eslint-disable-next-line no-param-reassign
          selected = key;
        }
        return selected;
      }, "");

      this.selectedIconLibKey = selectedIconGroup;
    }
  }
};
</script>

<style>
</style>
